import { render, staticRenderFns } from "./LeaderboardInstructions.vue?vue&type=template&id=4d726403&scoped=true&"
import script from "./LeaderboardInstructions.vue?vue&type=script&lang=js&"
export * from "./LeaderboardInstructions.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardInstructions.vue?vue&type=style&index=0&id=4d726403&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d726403",
  null
  
)

export default component.exports